module.exports = __webpack_public_path__ + "efa0caace161dc602d12f19b8845f750.pdf";